import { EmptyState, OctagonAlertIcon } from '@buffer-mono/popcorn'

import type { ChannelType } from '~publish/pages/Community/types'

import { ChannelRefreshCard } from './ChannelRefreshCard'

import styles from './ChannelNeedsRefresh.module.css'

import type { JSX } from 'react'

export function ChannelNeedsRefresh({
  channel,
}: {
  channel: ChannelType
}): JSX.Element {
  return (
    <EmptyState variant="critical" className={styles.emptyState}>
      <EmptyState.Icon>
        <OctagonAlertIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>
        We&apos;re having trouble connecting to your channel
      </EmptyState.Heading>
      <EmptyState.Description>
        Refresh the connection to start replying to comments.
      </EmptyState.Description>
      <EmptyState.Actions className={styles.actions}>
        <ChannelRefreshCard
          channel={channel}
          cta="publish-comments-button-refresh-1"
        />
      </EmptyState.Actions>
    </EmptyState>
  )
}
